/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgeFieldContextConfigPageType from '@jira/spa-apps__forge-field-contextual-config/src/ForgeFieldContextConfigPageShellWithAnalytics.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgeFieldContextConfigPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgeFieldContextConfigPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-field-context-config", jiraSpaEntry: "async-forge-spa-field-context-config" */ '@jira/spa-apps__forge-field-contextual-config/src/ForgeFieldContextConfigPageShellWithAnalytics.tsx'
			),
	);

export const ForgeFieldContextConfigPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyForgeFieldContextConfigPage}
		pageId="forge-spa-field-context-config"
		shouldShowSpinner
	/>
);

export default ForgeFieldContextConfigPage;
